<template>
  <div class="container-fluid" :class="{'first-view': tab === 'first'}">
    <Breadcrumb v-if="tab !== 'first'" :values="{ Home: '/', 'Category Profile': '' }"></Breadcrumb>
    <img v-if="tab === 'first'" class="logo" :src="logo"/>
    <div v-if="searchFilters.essentials" class="animated fadeIn" :class="{'animated-style': tab === 'first'}" :style="tab === 'first' ? 'width: 100%; max-width: 1300px' : 'min-height: 100%;'">
      <div class="card view-wrapper">
        <template v-if="tab === 'first'">
          <div class="card-body view">
            <div class="header">
              <div class="title">
                <!--          <font-awesome-icon icon="trophy" size="4x"></font-awesome-icon>-->
                <div>Category Profile</div>
              </div>
              <div class="steps">
                <el-steps :active="0" finish-status="success">
                  <el-step title="Step 1"></el-step>
                </el-steps>
              </div>
            </div>
            <div class="form-wrapper">
              <div class="d-flex flex-column justify-content-center w-100">
                <span class="subtitle" style="text-align: center">
                  If you'd like to narrow your search, please select one or more criteria below:
                </span>
                <div class="form-group d-flex justify-content-center">
                  <el-select class="select-group-item" :model-value="searchFilters.essentials.region.value" @change="changeRegionData"
                               placeholder="Select region of the study" multiple filterable collapse-tags>
                    <el-option-group label="Press Tab/Escape to exit">
                      <template v-for="value in getMetadataTagValues('region')">
                        <el-option
                            v-if="!['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia'].includes(value.value)"
                            :key="value.value"
                            :label="value.value"
                            :value="value.value">
                          <span style="float: left">{{value.value}}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                        </el-option>
                      </template>
                      <template v-for="value in getAPACcounts()">
                        <el-option v-if="value.value === 'APAC'" :key="value.value" :label="value.value"
                                   :value="value.value">
                          <span style="float: left">{{value.value}}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                        </el-option>
                        <el-option v-else :key="value.value" :label="value.value"
                                   :value="value.value">
                          <span style="float: left; margin-left: 10px">{{value.value}}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                        </el-option>
                      </template>
                    </el-option-group>
                  </el-select>
                  <el-select class="select-group-item"
                             v-model="searchFilters.essentials.category.value"
                             placeholder="Select category"
                             @change="updateDropdownValues()"
                             multiple filterable collapse-tags>
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                          v-for="value in getMetadataTagValues('category')"
                          :key="value.value" :label="value.value" :value="value.value">
                        <span style="float: left">{{value.value}}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                </div>
                <template v-if="yearsObject != null && formData.year.length === 2">
                  <div class="row d-flex justify-content-center" style="align-items: center; margin-top: 20px">
                    <div class="col-lg-4 col-md-4 input-wrapper">
                      <div class="slider-wrapper">
                        <el-slider v-model="yearsObject.value" range
                                   :min="yearsObject['min']"
                                   :max="yearsObject['max']"
                                   :marks="yearsObject['marks']"
                                   @change="parseYears()"
                                   show-stops
                        >
                        </el-slider>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div>
              <div class="d-flex justify-content-end">
                <button class="btn next-button" @click="nextPage">Search</button>
              </div>
              <div class="footnote">
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="banner">
            <div class="banner-overlay"></div>
            <div class="banner-title"><span>Category profile</span></div>
          </div>
          <div class="category-profile-content" style="padding: 20px 0 40px">
            <div class="form-wrapper">
              <div class="form-inputs">
                <div class="row justify-content-center w-50 mr-5">
                  <div class="col-6">
                    <div class="input-wrapper mt-2">
                      <label>Category</label>
                      <el-select
                          v-model="searchFilters.essentials.category.value"
                          placeholder="Select values" filterable multiple collapse-tags
                          @change="updateDropdownValues()"
                      >
                        <el-option-group label="Press Tab/Escape to exit">
                          <el-option
                              v-for="value in getMetadataTagValues('category')"
                              :key="value.value" :label="value.value" :value="value.value">
                            <span style="float: left">{{value.value}}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="input-wrapper mt-2">
                      <label>Region</label>
                      <el-select :model-value="searchFilters.essentials.region.value" @change="changeRegionData"
                                 placeholder="Select data" multiple filterable collapse-tags>
                        <el-option-group label="Press Tab/Escape to exit">
                          <template v-for="value in getMetadataTagValues('region')">
                            <el-option
                                v-if="!['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia'].includes(value.value)"
                                :key="value.value"
                                :label="value.value"
                                :value="value.value">
                              <span style="float: left">{{value.value}}</span>
                              <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                            </el-option>
                          </template>
                          <template v-for="value in getAPACcounts()">
                            <el-option v-if="value.value === 'APAC' && value.count" :key="value.value" :label="value.value"
                                       :value="value.value">
                              <span style="float: left">{{value.value}}</span>
                              <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                            </el-option>
                            <el-option v-else-if="value.count" :key="value.value" :label="value.value"
                                       :value="value.value">
                              <span style="float: left; margin-left: 10px">{{value.value}}</span>
                              <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                            </el-option>
                          </template>
                        </el-option-group>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="input-wrapper mt-2">
                      <label>Product</label>
                      <el-select
                          v-model="searchFilters.essentials.product.value"
                          placeholder="Select values" filterable multiple collapse-tags
                          @change="updateDropdownValues()"
                      >
                        <el-option-group label="Press Tab/Escape to exit">
                          <el-option
                              v-for="value in getMetadataTagValues('product_type')"
                              :key="value.value" :label="value.value" :value="value.value">
                            <span style="float: left">{{value.value}}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="input-wrapper mt-2">
                      <label>Client</label>
                      <el-select
                          v-model="searchFilters.essentials.client.value"
                          placeholder="Select values" filterable multiple collapse-tags
                          @change="updateDropdownValues()"
                      >
                        <el-option-group label="Press Tab/Escape to exit">
                          <el-option
                              v-for="value in getMetadataTagValues('client')"
                              :key="value.value" :label="value.value" :value="value.value">
                            <span style="float: left">{{value.value}}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center align-items-center w-50 ml-5">
                  <div class="col-12 form-slider">
                    <div class="slider-wrapper" style="margin: auto; width: 97%;">
                      <el-slider
                          v-if="Object.keys(yearsObject).length"
                          v-model="yearsObject.value"
                          range
                          :min="yearsObject.min"
                          :max="yearsObject.max"
                          :marks="yearsObject.marks"
                          @change="parseYears()"
                          show-stops
                      >
                      </el-slider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <Loader :show="loading" :fixed="false" style="z-index: 9;"/>
              <div class="main-chart">
                <div class="chart-title">Fragrance Families frequency (in %)</div>
                <div class="main-chart-canvas">
                  <canvas id="bar-chart" ref="barChartCanvas"></canvas>
                </div>
              </div>
              <div v-if="selectedTag" class="side-chart">
                <div class="chart-title">Top {{selectedTag}} fragrances based on T2B liking</div>
                <HorizontalBarChart v-if="Object.keys(sideChartData).length" :chart-data="sideChartData"
                                    :options="sideChartOptions"
                                    style="height: 400px"></HorizontalBarChart>
                <div v-else-if="!loading">
                  <span>No data available for this set of filters.</span>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <button class="btn next-button" @click="nextPage">Update Search</button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import { mapActions, mapGetters } from 'vuex'

import Breadcrumb from '../components/shared/Breadcrumb'

import getInitialFilters from '../constants/searchFilters'
import studiesActions from '../store/modules/studies/actionTypes'
import generalActions from '../store/modules/general/actionTypes'
import studiesGetters from '../store/modules/studies/getterTypes'
import HorizontalBarChart from '../components/shared/HorizontalBarChart'
import searchFunctions from '../helpers/searchFunctions'
import Loader from '../components/shared/Loader'
import logo from '../assets/images/logos/Iris-Grey.svg'
import { Chart as ChartJS } from 'chart.js'
import { registerChartComponents } from '../components/shared/chartSetup'

export default {
  name: 'CategoryProfile',
  components: {
    Loader,
    Breadcrumb,
    HorizontalBarChart
  },
  data () {
    return {
      formData: {
        year: []
      },
      fields: [],
      loading: false,
      interval: null,
      searchFilters: {},
      parsedFields: {},
      analyticFields: {},
      previousRegionValues: [],
      tab: 'first',
      yearsObject: null,
      categoryBarChart: null,
      selectedBarId: null,
      selectedTag: '',
      logo
    }
  },
  computed: {
    ...mapGetters({
      analytics: studiesGetters.GET_ANALYTICS,
      metricsJobId: studiesGetters.GET_METRICS_JOB_ID,
      tendencies: studiesGetters.GET_ANALYTICS_TENDENCIES
    }),
    chartData () {
      const chartSource = this.tendencies && this.tendencies.chart_data ? this.tendencies.chart_data : {}
      const tableData = this.tendencies && Array.isArray(this.tendencies.table_data) ? this.tendencies.table_data : []
      let labels = []
      let values = []

      if (Array.isArray(chartSource.labels) && Array.isArray(chartSource.data)) {
        labels = chartSource.labels
        values = chartSource.data.map(this.parseNumericValue)
      } else if (chartSource && typeof chartSource === 'object') {
        const entries = Object.entries(chartSource)
        labels = entries.map(([key]) => key)
        values = entries.map(([, value]) => this.parseNumericValue(value))
      }

      // Fallback for cases where backend chart_data is empty but table_data is present.
      if ((!labels.length || !values.length) && tableData.length) {
        labels = tableData.map(row => row.name || '')
        values = tableData.map(row => {
          const metric = row.percentage != null ? row.percentage : row.count
          return this.parseNumericValue(metric)
        })
      }

      if (values.length && values.every(v => v === 0) && tableData.length) {
        const countValues = tableData.map(row => this.parseNumericValue(row.count))
        if (countValues.some(v => v > 0)) {
          values = countValues
        }
      }

      if (!labels.length || !values.length) return {}

      return this.tendencies && Object.keys(this.tendencies).length ? {
        labels,
        datasets: [{
          label: 'Count',
          backgroundColor: values.map((el, idx) => idx === this.selectedBarId ? 'rgba(105,56,150,0.89)' : '#A3A0FB80'),
          data: values
        }]
      } : {}
    },
    sideChartData () {
      return this.analytics && this.analytics.results && this.analytics.results.length ? {
        labels: this.analytics.results.map(el => el.name ? el.name : el.prod),
        datasets: [{
          label: 'Top 2 liking',
          backgroundColor: 'rgba(105,56,150,0.89)',
          data: this.analytics.results.map(el => this.parseNumericValue(el['liking.top_2_box']))
        }]
      } : {}
    },
    mainChartOptions () {
      return {
        scales: {
          y: {
            beginAtZero: true
          }
        },
        plugins: {
          legend: {
            display: false
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: async (evt, item) => {
          if (!item || !item.length) return
          const point = item[0]
          const tag = this.chartData.labels[point.index]
          this.selectedBarId = point.index

          this.selectedTag = tag
          if (tag !== 'No tag') await this.getFragranceData(tag)
        }
      }
    },
    sideChartOptions () {
      return {
        scales: {
          y: {
            grid: {
              display: false
            },
            ticks: {
              callback: function (value) {
                const label = String(this.getLabelForValue(value))
                return label.length > 28 ? `${label.substr(0, 25)}...` : label
              }
            }
          },
          x: {
            beginAtZero: true,
            min: 0,
            grid: {
              display: false
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  methods: {
    ...mapActions({
      getAnalyticsFields: studiesActions.FETCH_ANALYTICS_FIELDS,
      getTendencies: studiesActions.FETCH_TENDENCIES,
      queueAnalytics: studiesActions.QUEUE_METRIC_SEARCH,
      getAnalytics: studiesActions.CHECK_METRIC_JOB_STATUS,
      setOrClearFilters: studiesActions.SET_OR_CLEAR_SEARCH_FILTERS,
      getUpdatedDropdownValues: studiesActions.UPDATE_DROPDOWN_OPTIONS,
      getUpdatedMetricsDropdownValues: studiesActions.UPDATE_METRICS_DROPDOWN_OPTIONS,
      toggleLoading: generalActions.TOGGLE_LOADING
    }),
    parseNumericValue (value) {
      if (typeof value === 'number' && Number.isFinite(value)) return value
      if (value == null) return 0
      const parsed = Number(String(value).replace(/[^0-9.-]/g, ''))
      return Number.isFinite(parsed) ? parsed : 0
    },
    renderMainBarChart () {
      const canvas = this.$refs.barChartCanvas
      const chartData = this.chartData
      if (!canvas || !chartData || !Array.isArray(chartData.labels) || !chartData.labels.length) {
        if (this.categoryBarChart) {
          this.categoryBarChart.destroy()
          this.categoryBarChart = null
        }
        return
      }

      registerChartComponents()
      if (this.categoryBarChart) {
        this.categoryBarChart.destroy()
      }
      this.categoryBarChart = new ChartJS(canvas, {
        type: 'bar',
        data: chartData,
        options: this.mainChartOptions
      })
    },
    async nextPage () {
      this.loading = true
      this.tab = 'second'
      this.selectedTag = ''
      this.selectedBarId = ''
      await this.getTendencies({
        q: searchFunctions.parseDataForSearch(this.searchFilters),
        data: { return: 'percentage', groupby: 'perfume_characteristics.family' }
      })
      this.loading = false
    },
    async getFragranceData (tag) {
      this.loading = true
      this.parseYears()
      this.searchFilters.fragranceDetails.family.value = [tag]
      this.searchFilters.metrics.threshold = {
        applyThreshold: true,
        amount: 5,
        desc: true,
        type: 'fragrances'
      }
      this.searchFilters.metrics.metricsList = [{
        metricType: { label: 'Metric type', key: 'metric_type', value: 'performance' },
        metric: { label: 'Metric', key: 'metric', value: 'liking' },
        aggregation: { label: 'Aggregation', key: 'aggregation', value: 'top_2_box' }
      }]
      await this.queueAnalytics({ q: searchFunctions.parseDataForSearch(this.searchFilters) })
      this.interval = setInterval(async () => {
        const data = await this.getAnalytics(this.metricsJobId)
        if (data) {
          clearInterval(this.interval)
          this.loading = false
        }
      }, 3000)
    },
    parseYears () {
      this.searchFilters.essentials.startYear.value = this.yearsObject.value[0]
      this.searchFilters.essentials.endYear.value = this.yearsObject.value[1]
    },
    previousPage () {
      this.tab = 'first'
    },
    getAPACcounts () {
      if (this.fields.length) {
        const tags = this.fields[0].data.find(el => el.field === 'region')
        if (tags) {
          const filteredValues = tags.options.filter(el => ['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia'].includes(el.value))
          const counts = filteredValues.map(el => el.count)
          const count = counts.reduce((a, b) => {
            return a + b
          }, 0)
          const aspacObj = { value: 'APAC', count }
          filteredValues.push(aspacObj)
          return filteredValues.sort((a, b) => {
            return a.value > b.value ? 1 : a.value < b.value ? -1 : 0
          })
        }
      }
      return []
    },
    async updateDropdownValues () {
      if (this.searchFilters) {
        const data = searchFunctions.parseDataForSearch(this.searchFilters, true)
        const res = await this.getUpdatedDropdownValues({ query: data.query })
        this.fields = res.data.fields
        this.parseFields()
      }
    },
    getMetadataTagValues (tag) {
      if (this.fields.length) {
        const tags = this.fields[0].data.find(el => el.field === tag)
        return tags ? tags.options : []
      }
      return []
    },
    parseFields () {
      const seekingFields = ['Business Unit', 'Category', 'Client', 'Region', 'Year']
      const collectedFields = {}
      const data = this.fields[0]['data']
      for (let i = 0; i < data.length; ++i) {
        if (seekingFields.includes(data[i].label)) {
          if (data[i].type === 'category') {
            const options = []
            for (let j = 0; j < data[i].options.length; ++j) {
              let { count, value } = data[i].options[j]
              if (data[i].label === 'Year') value = parseInt(value)
              options.push([value, count])
            }

            collectedFields[data[i].label] = options
          }
        }
      }

      this.parsedFields = collectedFields
      const years = [...this.parsedFields['Year']]
      if (years[0]) {
        const [firstYear, lastYear] = [years[0][0], years[years.length - 1][0]]
        this.formData.year = [String(firstYear), String(lastYear)]
        this.yearsObject = {
          min: firstYear,
          max: lastYear,
          marks: { [firstYear]: String(firstYear), [lastYear]: String(lastYear) },
          value: [firstYear, lastYear]
        }
      }
    },
    changeRegionData (data) {
      const mainRegion = 'APAC'
      const subRegions = ['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia']
      if (data.includes(mainRegion)) {
        if (!this.previousRegionValues.includes(mainRegion)) {
          data = [...new Set([...data, ...subRegions])]
        } else {
          if (data.filter(el => el !== mainRegion).length < 3) {
            const index = data.indexOf(mainRegion)
            data.splice(index, 1)
          }
        }
      } else {
        if (this.previousRegionValues.includes(mainRegion)) {
          data = data.filter(x => !subRegions.includes(x))
        }
      }
      this.$set(this.searchFilters.essentials.region, 'value', data)
      this.previousRegionValues = data
      this.updateDropdownValues()
    }
  },
  beforeUnmount () {
    if (this.categoryBarChart) {
      this.categoryBarChart.destroy()
      this.categoryBarChart = null
    }
  },
  async beforeMount () {
    if (!this.searchFilters.length) {
      this.toggleLoading(true)
      const res = await this.getUpdatedDropdownValues({ query: [] })
      this.fields = res.data.fields
      this.parseFields()
      this.searchFilters = _.cloneDeep(getInitialFilters.getInitialFilters())
      this.toggleLoading(false)
    }
  },
  watch: {
    tab (value) {
      if (value === 'second') {
        this.$nextTick(() => this.renderMainBarChart())
      }
    },
    chartData: {
      deep: true,
      handler () {
        this.$nextTick(() => this.renderMainBarChart())
      }
    },
    selectedTag () {
      setTimeout(() => this.renderMainBarChart(), 10)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

hr.space {
  margin: 1.5em 0;
  visibility: hidden;
}

.container-fluid.first-view {
  padding: 99px 87px !important;
  background-image: url("../assets/images/backgrounds/IRIS-background-720p.jpg");
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container-fluid {
  height: 100%;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.card {
  margin-bottom: 0;
  border: 0;
  width: 100%;
  background-color: rgba(255,255,255,0.93);
}

.view {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 3px 6px #000000;
  padding: 0;
  width: 100%;

  .header {
    display: flex;
    justify-content: space-between;

    .steps {
      height: 62px;
      margin-top: 20px;
      margin-right: 29px;
    }
  }

  .form-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 33px;
    @media screen and (min-width: $break-lg) {
      font-size: 20px;
      line-height: 38px;
    }
    @media screen and (min-width: $break-xl) {
      font-size: 24px;
      line-height: 43px;
    }
    @media screen and (min-width: $break-xxl) {
      font-size: 28px;
      line-height: 48px;
    }
    letter-spacing: 0;
    color: $dusty-blue;
    margin: 15px 0;
    @media screen and (min-width: $break-lg) {
      margin: 20px 0
    }
    @media screen and (min-width: $break-xl) {
      margin: 25px 0
    }
    @media screen and (min-width: $break-xxl) {
      margin: 30px 0
    }

    .first-form-row {
      margin-bottom: 30px;
    }

    .best-worst-switch {
      margin: 0 15px;
      border-radius: 4px;
      box-shadow: 0 1px 4px #00000026;
    }

    .type-switch {
      margin: 0 15px;
      border-radius: 4px;
      box-shadow: 0 1px 4px #00000026;
    }

    .number-input {
      margin-left: 20px;
      width: 98px !important;
      height: 43px !important;
      @media screen and (min-width: $break-lg) {
        height: 47px;
      }
      @media screen and (min-width: $break-xl) {
        height: 51px;
      }
      @media screen and (min-width: $break-xxl) {
        height: 55px;
      }
    }
  }

  .next-button {
    font-family: 'Open Sans', sans-serif;
    font-weight: 900;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0;
    background-color: $blueberry;
    color: white;
    text-transform: uppercase;
    border-radius: 4px;
    margin-right: 30px;
    margin-bottom: 15px;
    width: 160px;
    height: 38px;
    padding: 5px;
    @media screen and (min-width: $break-lg) {
      margin-right: 40px;
      margin-bottom: 20px;
      width: 180px;
      height: 40px;
      padding: 2px;
    }
    @media screen and (min-width: $break-xl) {
      margin-right: 60px;
      margin-bottom: 20px;
      width: 200px;
      height: 42px
    }
    @media screen and (min-width: $break-xxl) {
      margin-right: 80px;
      margin-bottom: 25px;
      width: 240px;
      height: 44px
    }
    transition: background-color 0.2s linear;
    &:hover {
      background-color: #9256D9;
    }
  }
}

.title {
  margin-top: 20px;
  margin-left: 32px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 900;
  font-size: 30px;
  line-height: 24px;
  letter-spacing: 0.8px;
  @media screen and (min-width: $break-lg) {
    font-size: 35px;
    line-height: 26px;
    letter-spacing: 0.8px;
    margin-top: 23px;
    margin-left: 37px;
  }
  @media screen and (min-width: $break-xl) {
    font-size: 40px;
    line-height: 28px;
    letter-spacing: 0.9px;
    margin-top: 26px;
    margin-left: 42px;
  }
  @media screen and (min-width: $break-xxl) {
    font-size: 45px;
    line-height: 30px;
    letter-spacing: 0.9px;
    margin-top: 29px;
    margin-left: 47px;
  }
  color: $pewter;
  text-transform: uppercase;
}

.footnote {
  height: 44px;
  background: transparent linear-gradient(268deg, #C961C5 0%, #DEBFDD 100%) 0% 0% no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
  opacity: 0.9;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media screen and (min-width: $break-lg) {
    height: 49px;
    span {
      font-size: 18px;
      line-height: 20px;
      margin-right: 50px;
    }
  }
  @media screen and (min-width: $break-xl) {
    height: 54px;
    span {
      font-size: 18px;
      line-height: 22px;
      margin-right: 55px;
    }
  }
  @media screen and (min-width: $break-xxl) {
    height: 59px;
    span {
      font-size: 20px;
      line-height: 25px;
      margin-right: 60px;
    }
  }

  span {
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 16px;
    line-height: 18px;
    color: $charcoal;
    margin-right: 45px;
  }
}

.logo {
  position: fixed;
  bottom: 20px;
  right: 50px;
  width: 6.5%;
  height: auto;
}

.banner {
  height: 130px;
  background: transparent linear-gradient(266deg, rgba(115,178,224, 0.73) 0%, rgba(0,39,204, 0.73) 100%) 0 0 no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #231A44;
  border-left: 0;
  border-right: 0;
  position: relative;

  .banner-overlay {
    z-index: 1;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("../assets/images/headers/header-datapoints.svg");
    background-size: cover;
  }

  .banner-title {
    position: absolute;
    z-index: 2;
    width: 410px;
    height: 56px;
    margin-left: 34px;
    margin-top: 13px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 45px;
    line-height: 56px;
    letter-spacing: 0.9px;
    color: white;
    text-transform: uppercase;
    font-weight: 900;
  }
}

.form-wrapper {
  padding: 0 40px;
  .form-inputs {
    display: flex;
  }
}

.input-wrapper label {
  font-size: 13px;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  color: $input-label;
  margin-bottom: 2px;
  margin-left: 2px;
}

.chart-wrapper {
  margin: 54px 93px 0;
  display: flex;

  .main-chart {
    margin-right: 40px;
    display: flex;
    flex-direction: column;
    flex: 1;

    .main-chart-canvas {
      position: relative;
      width: 100%;
      height: 400px;

      canvas {
        width: 100% !important;
        height: 100% !important;
        display: block;
      }
    }
  }

  .side-chart {
    margin-left: 40px;
    flex-direction: column;
    display: flex;
    flex: 1;
  }

  .chart-title {
    height: 41px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 33px;
    line-height: 24px;
    letter-spacing: 0;
    color: #4D4F5C;
  }
}

.button-wrapper {
  display: flex;
  justify-content: flex-start;
  margin-top: 30px;

  .back-button {
    width: 240px;
    height: 48px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 900;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0;
    background: $pewter;
    color: white;
    text-transform: uppercase;
    border-radius: 4px;
    margin-left: 125px;
    margin-bottom: 55px;
  }
}

.title svg {
  margin-right: 0.5em;
}
</style>
<style lang="scss">
@import "../assets/scss/variables";

.select-group-item {
  .el-input__inner {
    font-family: 'Helvetica', sans-serif;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0;
    color: $default-focus;
    background-color: white !important;
    border: 2px solid #EBEDED !important;
    border-radius: 6px;
  }
}
</style>
